import apiHandler from "../../../../api/core/apiHandler";

const paymentHistoryCxcApi =
  apiHandler("receivables");

export default paymentHistoryCxcApi;